import { GridLogicOperator } from '@mui/x-data-grid-premium'
import { UnknownError } from '@omnea-digital/toolbox'
import { FilterModel } from '@omnea-app/legacy/utils/savedFilters/validateFilterModel'
import { TableFilter } from '@omnea-app/org-settings/orgSettingsFrontendClient'
import { paths } from '@omnea-app/org-settings/orgSettingsHttpClient/orgSettingsGeneratedTypes'
import { TableFilterReference } from '@omnea-app/packages/universal/tables/tableFilterReference'

type ApiSavedFilter = paths['/table-filters']['get']['responses']['200']['content']['application/json'][number]

const isGridLogicOperator = (logicOperator: string | undefined): logicOperator is GridLogicOperator => {
  return Object.values(GridLogicOperator).includes(logicOperator as GridLogicOperator)
}

const isTableFilterReference = (reference: string): reference is TableFilterReference => {
  return Object.values(TableFilterReference).includes(reference as TableFilterReference)
}

export const sanitizeFilterModel = (filterModel: FilterModel | ApiSavedFilter['filters']): FilterModel => {
  if (filterModel.logicOperator !== undefined && !isGridLogicOperator(filterModel.logicOperator)) {
    throw new UnknownError({ message: `Invalid logicOperator: ${filterModel.logicOperator}` })
  }
  if (filterModel.quickFilterLogicOperator !== undefined && !isGridLogicOperator(filterModel.quickFilterLogicOperator)) {
    throw new UnknownError({ message: `Invalid quickFilterLogicOperator: ${filterModel.quickFilterLogicOperator}` })
  }

  const sanitized: FilterModel = {
    ...filterModel,
    logicOperator: filterModel.logicOperator,
    quickFilterLogicOperator: filterModel.quickFilterLogicOperator,
  }
  return sanitized
}

export const transformSavedFilter = (filter: ApiSavedFilter): TableFilter => {
  if (!isTableFilterReference(filter.reference)) {
    throw new UnknownError({ message: `Invalid reference: ${filter.reference}` })
  }
  const sanitizedFilters = sanitizeFilterModel(filter.filters)
  const result: TableFilter = {
    ...filter,
    filters: sanitizedFilters,
    reference: filter.reference,
  }
  return result
}
